module.exports = __webpack_public_path__ + "static/media/privacy.d1f4dcdc.jpg";